import React from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
// core components
import GridItem from "app/components/Grid/GridItem.js";
import GridContainer from "app/components/Grid/GridContainer.js";
import CustomInput from "app/components/CustomInput/CustomInput.js";
import Button from "app/components/CustomButtons/Button.js";
import Card from "app/components/Card/Card.js";
import CardBody from "app/components/Card/CardBody.js";
import CardFooter from "app/components/Card/CardFooter.js";
import axios from 'axios';
import PropTypes from 'prop-types';
import $ from 'jquery';
import Box from '@material-ui/core/Box';
import { Link } from '@material-ui/core';
import logo from "../../layout/europalogo.png";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

//React export class used to display the forgotten password page.
class ForgottenPassword extends React.Component {
    //constructor to set the React states and create the props
    constructor(props) {
        super(props);
        this.state = { items: [], loading: true, APIResponseText: []};
    }

    //Render method used to render the content of the page. 
    render() {
        const onSubmit = (e) => {
            e.preventDefault();

            const form = e.currentTarget;

            const formData = new FormData(form);

            const plainFormData = Object.fromEntries(formData.entries());
            const formDataJsonString = JSON.stringify(plainFormData);

            axios.post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/forgottenPassword`,
                formDataJsonString
            )
            .then(function (response) {
                if (response.data === "Updated") {
                    $("#sucess").show();
                    $("#nouser").hide();
                    $("#passwordmatch").hide();
                } else if (response.data === "Password Match") {
                    $("#sucess").hide();
                    $("#nouser").hide();
                    $("#passwordmatch").show();
                } else if (response.data === "User account not found") {
                    $("#sucess").hide();
                    $("#nouser").show();
                    $("#passwordmatch").hide();
                }                  
            })
            .catch(function (error) {

            });
        };

        const { classes } = this.props;

        return (
                <Box m={20}>
                    <GridContainer className={classes.root} align="center" justify="center">
                    <GridItem xs={12} md={6}>
                        <Card>
                            <div className={classes.header} style={{ backgroundColor: "#ee2e24", minHeight: "150px" }}>
                                <img src={logo} alt="logo" style={{ padding: "25px" }} />
                            </div>
                                <form onSubmit={onSubmit}>
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12}>
                                                <CustomInput
                                                    labelText="Email Address"
                                                    id="userEmailAddress"
                                                    name="userEmailAddress"
                                                    type="email"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true,
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12}>
                                                <CustomInput
                                                    labelText="New Password"
                                                    id="userNewPassword"
                                                    name="userNewPassword"
                                                    type="password"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true,
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12}>
                                                <CustomInput
                                                    labelText="Confirm Password"
                                                    id="userConfirmedPassword"
                                                    name="userConfirmedPassword"
                                                    type="password"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true,
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer align="center" justify="center">
                                             <GridItem xs={12} md={4}>
                                                <div id="sucess" style={{ display: "none" }}>
                                                    <Alert severity="success">
                                                        <AlertTitle>Password updated</AlertTitle>
                                                    </Alert>
                                                </div>
                                                <div id="nouser" style={{ display: "none" }}>
                                                    <Alert severity="error">
                                                        <AlertTitle>User account not found.</AlertTitle>
                                                    </Alert>
                                                </div>
                                                <div id="passwordmatch" style={{ display: "none" }}>
                                                    <Alert severity="error">
                                                        <AlertTitle> Password doesn't match.</AlertTitle>
                                                    </Alert>
                                                </div>
                                            </GridItem>
                                        </GridContainer>
                                </CardBody>
                                    <CardFooter>
                                        <Button color="primary" type="submit">Update Password</Button>
                                    <Link className={classes.buttonLink} href="/LeoSeaPortal/login" style={{ textDecoration: "none" }}><Button color="rose">Back To Login</Button></Link>
                                    </CardFooter>
                                </form>
                            </Card>
                        </GridItem>
                    </GridContainer>
                </Box>
            );
    }
}
//popTypes used the set the claases for the Forgotten Password form items
ForgottenPassword.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(ForgottenPassword);
